var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTestTube = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3366 1.34318L11.3394 2.67651L10.6727 2.67793L10.6926 12.0112C10.6957 13.484 9.50429 14.6804 8.03156 14.6836C6.5588 14.6867 5.36236 13.4953 5.35924 12.0226L5.33942 2.68925L4.67275 2.69067L4.66992 1.35734L11.3366 1.34318ZM9.3479 6.68075L6.68124 6.68641L6.69257 12.0197C6.69413 12.7561 7.29233 13.3518 8.02873 13.3502C8.76513 13.3487 9.36079 12.7505 9.35923 12.0141L9.3479 6.68075ZM8.68832 10.0155C9.05651 10.0147 9.35561 10.3125 9.3564 10.6807C9.35718 11.0489 9.05935 11.348 8.69115 11.3488C8.32295 11.3496 8.02385 11.0518 8.02307 10.6836C8.02228 10.3154 8.32012 10.0163 8.68832 10.0155ZM7.35074 8.01833C7.71894 8.01755 8.01804 8.31538 8.01882 8.68358C8.0196 9.05178 7.72177 9.35088 7.35357 9.35166C6.98537 9.35244 6.68627 9.05461 6.68549 8.68641C6.68471 8.31821 6.98254 8.01911 7.35074 8.01833ZM9.33941 2.68076L6.67275 2.68642L6.67841 5.35308L9.34507 5.34742L9.33941 2.68076Z",
    fill: "#00A962"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTestTube, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/TestTube.1ef1f7c4.svg";
export { ForwardRef as ReactComponent };